import { useMemo } from 'react';

import { useStatusContext } from 'pages/Status/context';

import { ICON, SUBTITLE, TITLE } from './constants';

interface JobStatusHook {
  icon: string;
  title: string;
  subtitle: string;
}

export default function useJobStatus(): JobStatusHook {
  const { job, jobCompanyInfo, isLoading } = useStatusContext();

  const name = useMemo(() => {
    if (!jobCompanyInfo || isLoading) return 'Your tradesperson';
    return jobCompanyInfo?.company_name || 'Your tradesperson';
  }, [jobCompanyInfo, isLoading]);

  const icon = useMemo(() => {
    if (!job || isLoading) return ICON.accepted;
    const status = job?.status;
    if (status === 'accepted') return ICON.accepted;
    if (status === 'declined') return ICON.declined;
    if (status === 'finished') return ICON.finished;
    return ICON.accepted;
  }, [job, isLoading]);

  const title = useMemo(() => {
    if (!job || isLoading) return TITLE.accepted;
    const status = job?.status;
    if (status === 'accepted') return TITLE.accepted;
    if (status === 'declined') return TITLE.declined;
    if (status === 'finished') return TITLE.finished;
    return TITLE.accepted;
  }, [job, isLoading]);

  const sub = useMemo(() => {
    if (!job || isLoading) return SUBTITLE.accepted;
    const status = job?.status;
    if (status === 'accepted') return SUBTITLE.accepted;
    if (status === 'declined') return SUBTITLE.declined;
    if (status === 'finished') return SUBTITLE.finished;
    return SUBTITLE.accepted;
  }, [job, isLoading]);

  const subtitle = sub.replace('$partner', name);

  return {
    icon,
    title,
    subtitle,
  };
}
